import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Layout } from './Layout';
import FeatherIcon from 'feather-icons-react';

// AXISREF397: simulationIsProduction gate removed — Simulate is visible to admins in all environments.
const adminNavItems = [
  { to: '/admin/sr-queue', label: 'SR Referrals', icon: 'inbox' as const },
  { to: '/admin/data', label: 'Data', icon: 'database' as const },
  { to: '/admin/sr-integration', label: 'SR Integration', icon: 'link' as const },
  { to: '/admin/simulate', label: 'Simulate', icon: 'file-text' as const },
  { to: '/admin/validation-health', label: 'Validation Health', icon: 'activity' as const },
];

export const AdminLayout: React.FC = () => {
  return (
    <Layout>
      <div className="admin-shell">
        <aside className="admin-sidebar" aria-label="Admin navigation">
          <div className="admin-sidebar-header">
            <FeatherIcon icon="settings" size={18} />
            <span>Admin</span>
          </div>
          <nav className="admin-sidebar-nav">
            {adminNavItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `admin-sidebar-link${isActive ? ' admin-sidebar-link--active' : ''}`
                }
              >
                <FeatherIcon icon={item.icon} size={16} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </Layout>
  );
};
